import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// // Save original
// const originalNavigate = Router.prototype.navigate;

// // Patch
// Router.prototype.navigate = function (commands: any[], extras?: NavigationExtras): Promise<boolean> {
//   console.log('router.navigate called with:', commands, extras, new Error().stack);
//   return originalNavigate.apply(this, [commands, extras]);
// };

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
